
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Apprenti from '@/extend/classes/Apprenti';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeApprenti' })

export default class storeApprenti extends VuexModule {
  // States
  private reccords: Apprenti[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get apprentiLoading (): boolean {
    return this.dataLoading;
  }
  private get apprentiRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get apprentiLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewApprenti() {
    return (): Apprenti => { 
      return this.getApprenti(0, true);
    }
  }

  
  public get getApprenti () {
    return (id: number, canCreate = false): Apprenti => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Apprenti can't be 0")
        return new Apprenti();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Apprenti();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Apprenti.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromApprenti(data.reccords[0] as Apprenti);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listApprenti (): Apprenti[] {
    return this.reccords;
  }

  public get listConfigApprenti (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mApprentiRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mApprentiClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mApprentiLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mApprentiLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Apprenti.fromJson(reccord as Apprenti));
    })
    Apprenti.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mApprentiConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mApprentiCreated (obj: Apprenti): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareApprenti(obj)) {
          api.fromApprenti(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareApprenti(obj)) {
            api.fromApprenti(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mApprentiUpdated (obj: Apprenti): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareApprenti(obj)) {
          api.fromApprenti(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mApprentiDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerApprenti (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.apprentiRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerApprenti(this.apprentiCreated, this.apprentiUpdated, this.apprentiDeleted);
          this.mApprentiRegistered();
        } else {
          setTimeout(() => resolve(this.registerApprenti(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.apprentiLoading && !this.apprentiLoaded) {
          this.mApprentiLoading(true);
          return Apprenti.list(filter)
            .then((data: ListData) => {
              this.mApprentiLoaded(data);
              this.mApprentiLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredApprenti (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.apprentiLoading) {
        this.mApprentiLoading(true);
        return Apprenti.list(filter)
          .then((data: ListData) => {
            this.mApprentiLoaded(data);
            this.mApprentiLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createApprenti (obj: Apprenti): Promise<Apprenti> {
    return new Promise((resolve, reject) => {
      return Apprenti.fromJson(obj).createForStoreApprenti()
        .then((reccords) => {
          this.mApprentiCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateApprenti (obj: Apprenti): Promise<Apprenti> {
    return new Promise((resolve, reject) => {
      return Apprenti.fromJson(obj).updateForStoreApprenti()
        .then((reccords) => {
          this.mApprentiUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteApprenti (obj: Apprenti): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Apprenti.fromJson(obj).deleteForStoreApprenti()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mApprentiDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private apprentiCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mApprentiConfigUpdated(config)
    const obj = objConfig.obj as Apprenti;
    this.mApprentiCreated(Apprenti.fromJson(obj));
  }

  @Action
  private apprentiUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mApprentiConfigUpdated(config)
    const obj = objConfig.obj as Apprenti;
    this.mApprentiUpdated(Apprenti.fromJson(obj));
  }

  @Action
  private apprentiDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Apprenti;
    this.mApprentiDeleted(obj.id);
  }
}
